import React, { useCallback } from 'react';

import { useAuth } from '../context/AuthContext';

import { SUBSCRIPTION_DAYS } from '../utils/subscriptions';

import SubscriptionDaysRing from './SubscriptionDaysRing';

import NotificationBell from './NotificationBell';

import { subscribeStudentNotifications } from '../utils/notifications';



/**

 * Top-right profile chip with subscription countdown ring (all app screens).

 */

export default function ProfileHeaderActions({ variant = 'light', compact = false }) {

  const { currentUser, subscriptionInfo } = useAuth();



  const subscribe = useCallback(

    (cb) => subscribeStudentNotifications(currentUser?.uid, cb),

    [currentUser?.uid]

  );



  if (!currentUser) return null;



  const displayName = currentUser.displayName || currentUser.email?.split('@')[0] || 'Student';

  const initials = displayName.slice(0, 2).toUpperCase();

  const daysLeft = subscriptionInfo?.daysLeft ?? 0;

  const totalDays = subscriptionInfo?.totalDays || SUBSCRIPTION_DAYS;



  const tooltip = subscriptionInfo?.isAdmin

    ? 'Full admin access'

    : daysLeft === 0

      ? 'No active subscription'

      : `${daysLeft} day${daysLeft === 1 ? '' : 's'} of subscription remaining`;



  return (

    <div className={`sba-profile-header-actions${compact ? ' sba-profile-header-actions--compact' : ''}`}>

      <NotificationBell subscribe={subscribe} variant={variant} />

      {subscriptionInfo && (

        <div className="sba-subscription-chip" title={tooltip} aria-label={tooltip}>

          <SubscriptionDaysRing

            daysLeft={daysLeft}

            totalDays={totalDays}

            size={compact ? 38 : 44}

            variant={variant}

          />

        </div>

      )}

      <div

        className={`sba-profile-avatar${variant === 'dark' ? ' sba-profile-avatar--on-dark' : ''}`}

        title={displayName}

        aria-label={`Profile: ${displayName}`}

      >

        {initials}

      </div>

    </div>

  );

}

